export const names = {
    firsts: [
        "Lars",
        "Fjörd",
        "Kröns",
        "Yasmin",
        "Dirk",
        "Bronson",
        "Kurt",
        "Klaus",
        "Hans",
        "Earl",
        "Ivanna",
        "Ol' Man",
        "Rusty",
        "Jerome",
        "Pierre",
        "Jörg",
        "Harrison",
        "Mr.",
        "Mrs.",
        "Ms.",
        "Red",
        "Buster",
        "Ingrid",
        "Julius",
        "Sherman",
        "Junior",
        "Yuri",
        "John",
        "Ryder",
        "Gary",
        "Ari",
        "Pekka",
        "Eliza",
        "Lisa",
        "Sally",
        "Jasmine",
        "Rita",
        "Marjorie",
        "Melissa",
        "Terrence",
        "Ulrich Von",
        "Chief",
        "Helga Von",
        "Dusty",
        "Krusty",
        "Count",
        "Matt",
        "Ben",
        "Jon",
        "Josh",
        "Misty",
        "Master",
        "Dr.",
        "Grandma",
        "Grandpa",
        "DJ",
        "Kitty",
        "Armando",
        "Santa",
        "Mother",
        "Buster",
        "Indiana",
        "Mama",
        "Papa",
        "Madame",
        "Monsieur",
        "Shawanna",
        "Cleopatra",
        "Ol'",
        "Constable",
        "Napoleon",
        "Mayor",
        "Detective",
        "Officer",
        "Trooper",
        "Lord",
        "Moby",
        "Ruth",
        "Scooter",
        "Kris",
        "Kathy",
        "Gerri",
        "Ron",
        "Percy",
        "Ronald",
        "Dean",
        "Quincy",
        "Margaret",
        "Nancy",
        "Buster",
        "Bartholamew",
    ],

    lasts: [
        "Jonesberg",
        "Ramsford",
        "Kirklinson",
        "Ringwald",
        "Von Buffington",
        "Craghammer",
        "Mangrove",
        "Trappe",
        "McFly",
        "Schultz",
        "McAvery",
        "Jergen",
        "Porter",
        "Winklecross",
        "Dillings",
        "Van Winkle",
        "Mandrake",
        "Sparks",
        "Burns",
        "Drury",
        "O'Hanney",
        "Kirk",
        "Giovanni",
        "King",
        "Larry",
        "Sanderson",
        "Portenson",
        "Smith",
        "Jenkins",
        "Lubbard",
        "Mantoya",
        "Pritchard",
        "Hansfield",
        "McDonald",
        "Rockford",
        "Higgs",
        "Jones",
        "Stone",
        "Jackson",
        "Jefferson",
        "Kennedy",
        "Franklin",
        "Potter",
        "Hunt",
        "Pierce",
        "Thornsburg",
        "Trumbull",
        "Bellamy",
        "Bernstein",
        "Yates",
        "Hadley",
        "Wright",
        "Michaels",
        "Norrin",
        "Norris",
        "Verplatt",
        "Vanderfleet",
        "Zynara",
        "Fleckstein",
        "Vance",
        "Chaplin",
        "Xavier",
        "Poole",
    ],

    suffixes: [
        "Esq.",
        "M.D.",
        "O.D.",
        "DDS",
        "PhD",
        "PMP",
        "Sr.",
        "Jr.",
        "II",
        "III",
        "IV",
        "CPA",
        "D.C.",
        "D.V.M",
        "Ret.",
        "R.N.",
        "D.M.D.",
        "NP",
    ],

    catFirsts: [
        "Scratchy",
        "Puffy",
        "Lydia",
        "Creampuff",
        "Sargeant",
        "Corporal",
        "Admiral",
        "Major",
        "Captain",
        "Fluffy",
        "Fuzzy",
        "Poofy",
        "Squeeky",
        "Hairball",
        "Fiddius",
        "Duke",
        "Archibald",
        "Polly",
        "Licky",
        "Whiskers",
        "Notorious",
        "Paws",
        "Sabretooth",
        "Gerard",
        "Heathcliff",
        "Garfield",
        "Fish Breath",
        "Scruffy",
        "Sassy",
        "Muncey",
        "Jellybeans",
        "DJ",
        "Lil",
        "Cat",
        "Sniffles",
        "Madam",
        "Veronicat",
        "Nacho",
        "Tabby",
        "Itchy",
        "Tigger",
        "Flea"
    ],

    catLasts: [
        "Snuggles",
        "McPreen",
        "Von Crunch",
        "Sparkles",
        "At Arms",
        "Lixalot",
        "Purrmeister",
        "Furbottom",
        "McFuzz",
        "the cat",
        "C-A-T",
        "The Fierce",
        "The Lazy",
        "Everkitten",
        "The Spiteful",
        "The Hidden",
        "Litterpaws",
        "Tailwind",
        "Tailspin",
        "The Admiral",
        "Biscuits",
        "The Captain",
        "Von Lickenstein",
        "Clawsby",
        "Furr",
        "Flufferton",
        "Shakespurr"
    ],

    dogFirsts: [
        "Detective",
        "Sparky",
        "Zooms",
        "Spot",
        "Chewey",
        "Mr.",
        "Mrs.",
        "Ms.",
        "Scruffy",
        "Surku",
        "Chloe",
        "Bilbo",
        "Sniffles",
        "Zeus",
        "Nose",
        "Smokey",
        "Tank",
        "Ninja",
        "Pierre",
        "Spartacus",
        "Ceasar",
        "Gruff",
        "Frank",
        "Ol' Boy",
        "Buddy",
        "Champ",
        "Bud",
        "President",
        "Commander",
        "Anderson",
        "Fang",
        "Pawtrick",
        "Benji",
        "Astro",
        "Bear",
        "Sir",
        "Captain",
        "Butch",
        "Pooch",
        "Hercules",
        "Cutey",
        "Scrappy",
        "Snout",
    ],

    dogLasts: [
        "the Chewer",
        "Licky Paws",
        "Stinkpaw",
        "Woofington",
        "Wigglebutt",
        "the Sleepy",
        "of Zoomies",
        "Treatsnatcher",
        "DoGoode",
        "Gudboi",
        "Content",
        "McFlea",
        "McBarks",
        "Barksalot",
        "the Tank",
        "Panter",
        "the Hungry",
        "Tailchaser",
        "Barkley",
        "the Sausage",
        "Needsabath",
        "Waggytail",
        "the Pouncer",
        "the Excited",
        "the Nosey",
        "McGraw",
        "the Happy",
        "the Miserable",
        "Peanut",
        "Shedz",
        "Jumpz",
        "Nomeansyes",
        "the Patient",
        "Furr",
        "Poopz",
        "Shakespaw",
        "Elizabark",
        "Woofy",
        "the Mutt",
        "B-I-N-G-O",
        "D-O-G",
        "Walleater",
        "Ballchaser",
        "Fetcher",
        "the Dumby",
        "the Protector",
        "Birdcatcher",
        "Squirrelchaser",
        "the Destroyer",
        "Scrapps",
        "Tricks",
        "Garbagepicker",
    ]

}



// WEBPACK FOOTER //
// ./src/Names.js